import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorRuleSetFormDataProviderFactory } from '../factory/IntegrityMonitorRuleSetFormDataProviderFactory';
import { IntegrityMonitorRuleSetFormBaseDataProvider } from '../dataProvider/IntegrityMonitorRuleSetFormBaseDataProvider';
import { RuleSetData } from '../types';

export class IntegrityMonitorRuleSetFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorRuleSetFormDataProviderFactory;
  public dataProvider: IntegrityMonitorRuleSetFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorRuleSetFormDataProviderFactory(),
    });
  }

  public async getRuleSetData(ruleSetId: string): Promise<RuleSetData> {
    return this.dataProvider.getRuleSetData(ruleSetId);
  }

  public async updateRuleSet(record: Object): Promise<Object | null> {
    return this.dataProvider.updateRuleSet(record);
  }

  public async createRuleSet(record: Object): Promise<Object | null> {
    return this.dataProvider.createRuleSet(record);
  }
}
